import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e9378af2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e9378af2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderCampusDetail: require('/home/etienne/AM-frontend/components/HeaderCampusDetail.vue').default,DetailCampusBannierMapBlock: require('/home/etienne/AM-frontend/components/DetailCampusBannierMapBlock.vue').default,DetailCampusSecondScreen: require('/home/etienne/AM-frontend/components/DetailCampusSecondScreen.vue').default,DetaiCampusAvantage1: require('/home/etienne/AM-frontend/components/DetaiCampusAvantage1.vue').default,DetaiCampusAvantage2: require('/home/etienne/AM-frontend/components/DetaiCampusAvantage2.vue').default,DetaiCampusAvantage3: require('/home/etienne/AM-frontend/components/DetaiCampusAvantage3.vue').default,DetailCampusCards: require('/home/etienne/AM-frontend/components/DetailCampusCards.vue').default,DetailCampusDiplomasList: require('/home/etienne/AM-frontend/components/DetailCampusDiplomasList.vue').default,DetailCampusOffresDAlternance: require('/home/etienne/AM-frontend/components/DetailCampusOffresDAlternance.vue').default,DetailCamusSliderNews: require('/home/etienne/AM-frontend/components/DetailCamusSliderNews.vue').default,JPOBannier: require('/home/etienne/AM-frontend/components/JPOBannier.vue').default})
